export default "__VITE_ASSET__DLR7Dr3g__"